export const LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_performance-websites/artifacts/fatrd2ga_LOGO.PNG";

export const CEO_PHOTO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_performance-websites/artifacts/qu5jya6q_hylx-641247c2-012c-45f3-940a-219a9a75b5b6.webp";

export const IMG = {
  heroBern:
    "https://images.unsplash.com/photo-1664459937096-d395cd77f8b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxiZXJuJTIwc3dpdHplcmxhbmQlMjBhcmNoaXRlY3R1cmUlMjBsdXh1cnl8ZW58MHx8fHwxNzg0ODMwNDQyfDA&ixlib=rb-4.1.0&q=85",
  aboutMeeting:
    "https://images.pexels.com/photos/7794034/pexels-photo-7794034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  metaAdsBg:
    "https://images.unsplash.com/photo-1760902419069-466f6f82c8b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwd2Vic2l0ZSUyMHdlYiUyMGRlc2lnbiUyMGludGVyZmFjZSUyMGRhcmslMjBsdXh1cnl8ZW58MHx8fHwxNzg0ODMwNDU1fDA&ixlib=rb-4.1.0&q=85",
  client:
    "https://images.pexels.com/photos/35452295/pexels-photo-35452295.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV_LINKS = [
  { id: "start", label: "Start" },
  { id: "partnerschaft", label: "Pakete" },
  { id: "ueber-uns", label: "Über uns" },
  { id: "ablauf", label: "Ablauf" },
  { id: "kontakt", label: "Kontakt" },
];
